import MeetCounselorSC from "./meet_counselor.styles";

import DrBMBImage from "../../../assets/profile_photo.png";

const MeetCounselor = ({ ref }) => {
  return <MeetCounselorSC>
    <h2 className="mentor-title" ref={ref}>MEET YOUR COUNSELOR</h2>

    <div className="mentor-card">
      {/* Left Card */}
      <div className="mentor-profile">
        <div className="mentor-image-wrapper">
          <img
            src={DrBMBImage}
            alt="Dr. Basavaraja B M"
            className="mentor-image"
          />
        </div>

        <div className="mentor-name">Dr. Basavaraja B M</div>
        <div className="mentor-role">Founder, Niratanka</div>
      </div>

      {/* Right Content */}
      <div className="mentor-content">
        <p>
          Dr. Basavaraja B M is a dedicated mental health professional with 17+ years of experience in higher education, student mentoring, and psychological wellbeing. He has received professional training under renowned psychiatrist and Padma Shri awardee Dr. C. R. Chandrashekar and has been volunteering at Samadhana Counselling Centre, Bengaluru since 2019. He currently serves as General Secretary of the Karnataka Mental Health Forum (since 2022), contributing to mental health awareness and advocacy.
        </p>

        <p>
          Dr. Basavaraja holds a PhD in Chemistry from Kuvempu University and completed post-doctoral research at IIT Kanpur. Motivated by his commitment to emotional wellbeing, he also earned an MSc in Psychology with distinction from Jain University. His integrative therapeutic approach combines Cognitive Behavioural Therapy (CBT), Dialectical Behaviour Therapy (DBT), mindfulness-based techniques, and person-centred counselling.
        </p>

        <p>
          He specializes in student wellbeing, academic stress, anxiety, depression, emotional regulation, and resilience building. Dr. Basavaraja provides a safe, respectful, and confidential space where individuals can openly explore their concerns. He believes that healing begins with being heard and focuses on empowering clients with practical skills for lasting psychological wellbeing.
        </p>
      </div>
    </div>
  </MeetCounselorSC>;
};

export default MeetCounselor;